import { useState, useEffect } from 'react';

// Hardcoded data
const smtpSettings = {
  server: 'smtp.company.com',
  port: 587,
  username: 'phishing@company.com',
  password: '********',
  useSSL: true,
  fromName: 'Company Security Team',
  replyTo: 'no-reply@company.com'
};

const domainsData = [
  { id: 1, domain: 'secure-company.net', status: 'active', spfConfigured: true, dkimConfigured: true, addedOn: '2023-07-15' },
  { id: 2, domain: 'company-verify.com', status: 'active', spfConfigured: true, dkimConfigured: true, addedOn: '2023-09-22' },
  { id: 3, domain: 'account-security.org', status: 'pending', spfConfigured: false, dkimConfigured: false, addedOn: '2023-10-18' },
];

const DomainSettings = () => {
  const [domains, setDomains] = useState([]);
  const [smtp, setSmtp] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('smtp');
  const [editingSmtp, setEditingSmtp] = useState(false);
  const [addingDomain, setAddingDomain] = useState(false);
  const [newDomain, setNewDomain] = useState('');
  
  // Form state for SMTP settings
  const [smtpForm, setSmtpForm] = useState(smtpSettings);
  
  useEffect(() => {
    // Simulate API calls
    setTimeout(() => {
      setDomains(domainsData);
      setSmtp(smtpSettings);
      setIsLoading(false);
    }, 1000);
  }, []);
  
  const handleSmtpChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSmtpForm({
      ...smtpForm,
      [name]: type === 'checkbox' ? checked : value,
    });
  };
  
  const handleSmtpSubmit = (e) => {
    e.preventDefault();
    // Simulate API call to update SMTP settings
    setTimeout(() => {
      setSmtp(smtpForm);
      setEditingSmtp(false);
      alert('SMTP settings updated successfully!');
    }, 500);
  };
  
  const handleAddDomain = (e) => {
    e.preventDefault();
    if (!newDomain) return;
    
    // Simulate API call to add domain
    const domain = {
      id: domains.length + 1,
      domain: newDomain,
      status: 'pending',
      spfConfigured: false,
      dkimConfigured: false,
      addedOn: new Date().toISOString().split('T')[0],
    };
    
    setDomains([...domains, domain]);
    setNewDomain('');
    setAddingDomain(false);
  };
  
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }
  
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">
        Email Configuration
      </h1>
      
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab('smtp')}
            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'smtp'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            SMTP Settings
          </button>
          <button
            onClick={() => setActiveTab('domains')}
            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'domains'
                ? 'border-primary-500 text-primary-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Domain Management
          </button>
        </nav>
      </div>
      
      {activeTab === 'smtp' && (
        <div className="card">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-lg font-semibold text-gray-900">SMTP Configuration</h2>
            {!editingSmtp && (
              <button 
                onClick={() => setEditingSmtp(true)}
                className="btn btn-outline"
              >
                Edit Settings
              </button>
            )}
          </div>
          
          {editingSmtp ? (
            <form onSubmit={handleSmtpSubmit}>
              <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div className="sm:col-span-3">
                  <label htmlFor="server" className="block text-sm font-medium text-gray-700">
                    SMTP Server
                  </label>
                  <div className="mt-1">
                    <input
                      type="text"
                      name="server"
                      id="server"
                      value={smtpForm.server}
                      onChange={handleSmtpChange}
                      className="input"
                      required
                    />
                  </div>
                </div>
                
                <div className="sm:col-span-3">
                  <label htmlFor="port" className="block text-sm font-medium text-gray-700">
                    Port
                  </label>
                  <div className="mt-1">
                    <input
                      type="number"
                      name="port"
                      id="port"
                      value={smtpForm.port}
                      onChange={handleSmtpChange}
                      className="input"
                      required
                    />
                  </div>
                </div>
                
                <div className="sm:col-span-3">
                  <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                    Username
                  </label>
                  <div className="mt-1">
                    <input
                      type="text"
                      name="username"
                      id="username"
                      value={smtpForm.username}
                      onChange={handleSmtpChange}
                      className="input"
                      required
                    />
                  </div>
                </div>
                
                <div className="sm:col-span-3">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                    Password
                  </label>
                  <div className="mt-1">
                    <input
                      type="password"
                      name="password"
                      id="password"
                      value={smtpForm.password}
                      onChange={handleSmtpChange}
                      className="input"
                      required
                    />
                  </div>
                </div>
                
                <div className="sm:col-span-3">
                  <label htmlFor="fromName" className="block text-sm font-medium text-gray-700">
                    From Name
                  </label>
                  <div className="mt-1">
                    <input
                      type="text"
                      name="fromName"
                      id="fromName"
                      value={smtpForm.fromName}
                      onChange={handleSmtpChange}
                      className="input"
                    />
                  </div>
                </div>
                
                <div className="sm:col-span-3">
                  <label htmlFor="replyTo" className="block text-sm font-medium text-gray-700">
                    Reply-To Email
                  </label>
                  <div className="mt-1">
                    <input
                      type="email"
                      name="replyTo"
                      id="replyTo"
                      value={smtpForm.replyTo}
                      onChange={handleSmtpChange}
                      className="input"
                    />
                  </div>
                </div>
                
                <div className="sm:col-span-6">
                  <div className="flex items-center">
                    <input
                      id="useSSL"
                      name="useSSL"
                      type="checkbox"
                      checked={smtpForm.useSSL}
                      onChange={handleSmtpChange}
                      className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    />
                    <label htmlFor="useSSL" className="ml-2 block text-sm text-gray-700">
                      Use SSL/TLS
                    </label>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 flex space-x-3">
                <button type="submit" className="btn btn-primary">
                  Save Changes
                </button>
                <button 
                  type="button" 
                  onClick={() => setEditingSmtp(false)}
                  className="btn btn-outline"
                >
                  Cancel
                </button>
              </div>
            </form>
          ) : (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm font-medium text-gray-500">SMTP Server</p>
                <p className="mt-1">{smtp.server}</p>
              </div>
              
              <div>
                <p className="text-sm font-medium text-gray-500">Port</p>
                <p className="mt-1">{smtp.port}</p>
              </div>
              
              <div>
                <p className="text-sm font-medium text-gray-500">Username</p>
                <p className="mt-1">{smtp.username}</p>
              </div>
              
              <div>
                <p className="text-sm font-medium text-gray-500">Password</p>
                <p className="mt-1">{smtp.password}</p>
              </div>
              
              <div>
                <p className="text-sm font-medium text-gray-500">From Name</p>
                <p className="mt-1">{smtp.fromName}</p>
              </div>
              
              <div>
                <p className="text-sm font-medium text-gray-500">Reply-To</p>
                <p className="mt-1">{smtp.replyTo}</p>
              </div>
              
              <div>
                <p className="text-sm font-medium text-gray-500">SSL/TLS</p>
                <p className="mt-1">{smtp.useSSL ? 'Enabled' : 'Disabled'}</p>
              </div>
            </div>
          )}
          
          <div className="mt-6 bg-blue-50 p-4 rounded-md">
            <p className="text-sm text-blue-700">
              These SMTP settings are used for sending phishing simulation emails. Make sure your SMTP server allows sending emails from the domains you'll be using in your campaigns.
            </p>
          </div>
        </div>
      )}
      
      {activeTab === 'domains' && (
        <div className="card">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-lg font-semibold text-gray-900">Domain Management</h2>
            {!addingDomain && (
              <button 
                onClick={() => setAddingDomain(true)}
                className="btn btn-primary"
              >
                Add Domain
              </button>
            )}
          </div>
          
          {addingDomain && (
            <div className="mb-6 p-4 border border-gray-200 rounded-md">
              <h3 className="text-md font-medium mb-3">Add New Domain</h3>
              
              <form onSubmit={handleAddDomain} className="flex flex-col md:flex-row gap-4">
                <div className="flex-grow">
                  <input
                    type="text"
                    value={newDomain}
                    onChange={(e) => setNewDomain(e.target.value)}
                    className="input"
                    placeholder="e.g. domain.com"
                    required
                  />
                </div>
                <div className="flex space-x-2">
                  <button type="submit" className="btn btn-primary">
                    Add
                  </button>
                  <button 
                    type="button" 
                    onClick={() => setAddingDomain(false)}
                    className="btn btn-outline"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          )}
          
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Domain
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    SPF
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    DKIM
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Added On
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {domains.map((domain) => (
                  <tr key={domain.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {domain.domain}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
                        ${domain.status === 'active' 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-yellow-100 text-yellow-800'
                        }`}>
                        {domain.status.charAt(0).toUpperCase() + domain.status.slice(1)}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {domain.spfConfigured ? (
                        <span className="text-green-600">Configured</span>
                      ) : (
                        <span className="text-red-600">Not Configured</span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {domain.dkimConfigured ? (
                        <span className="text-green-600">Configured</span>
                      ) : (
                        <span className="text-red-600">Not Configured</span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {domain.addedOn}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <button className="text-primary-600 hover:text-primary-900 mr-3">
                        Verify
                      </button>
                      <button className="text-red-600 hover:text-red-900">
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className="mt-6 bg-yellow-50 p-4 rounded-md">
            <h3 className="text-sm font-medium text-yellow-800 mb-1">DNS Configuration</h3>
            <p className="text-sm text-yellow-700">
              For each domain, you need to configure SPF and DKIM records to ensure deliverability and authenticity of your phishing simulation emails.
              Check our documentation for detailed instructions on how to set up these DNS records.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DomainSettings; 